var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444.24 323.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e6f8ff;}.cls-3{fill:#caedff;}.cls-11,.cls-4{fill:#bae6f7;}.cls-4{opacity:0.44;}.cls-11,.cls-22,.cls-4{isolation:isolate;}.cls-5{fill:#7bc7ff;}.cls-6{fill:#379cf7;}.cls-7{fill:#2481c6;}.cls-8{fill:#0a4d7a;}.cls-9{fill:#083954;}.cls-10{fill:#fff;}.cls-11{opacity:0.85;}.cls-12{fill:#fbbe42;}.cls-13{fill:#b1d7dd;}.cls-14{clip-path:url(#clip-path);}.cls-15{fill:#ffa683;}.cls-16{fill:#e57c5c;}.cls-17{fill:#004cba;}.cls-18,.cls-22{fill:#ed7d5a;}.cls-19{fill:#006cbc;}.cls-20{fill:#57bfff;}.cls-21{fill:#30afef;}.cls-22{opacity:0.58;}.cls-23{fill:#0a85e0;}.cls-24{clip-path:url(#clip-path-2);}.cls-25{fill:#ff5a5a;}.cls-26{clip-path:url(#clip-path-3);}.cls-27{fill:#f9a643;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-27.88 -80.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.51,
    cy: 219.64,
    r: 20.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-27.88 -80.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 148.14,
    cy: 281.54,
    r: 20.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-27.88 -80.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 217.49,
    cy: 342.47,
    r: 20.37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.12,392.94c0-6.32-95.46-11.45-213.2-11.45s-213.2,5.13-213.2,11.45,95.45,11.46,213.2,11.46S472.12,399.27,472.12,392.94Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.23,387.5c-24.84-.12-45-20.55-44.33-45.38.36-13.51,5.41-26.6,20.75-33.74,40.42-18.8-16-141,55.46-153.22S172.74,49.87,256.4,119.44,355.1,95,409.62,143.88s-35.72,110.92,32,142.88c44.63,21.08,30,58.91,14.85,82.24A44.41,44.41,0,0,1,419,389.12Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419,389.12A44.4,44.4,0,0,0,456.43,369c15.15-23.33,29.78-61.16-14.85-82.24-67.68-32,22.56-94-32-142.88S340.06,189,256.4,119.44C235.81,102.32,220.47,95.06,208,94a46.69,46.69,0,0,1,11.81,11.73c30.4,42.56,48.64,73.63,112.13,68.22s-28.37,105.37,21.61,118.21c33,8.47,28.6,59.39,4.66,96.68Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.16,173.82a46.34,46.34,0,0,1-14.45-4c-6.87-3.18-13-9.29-9.55-15.32,5.15-8.26-9.5-15.25-4.52-19.85,5.07-4.07,6.14-.7,4.18-9.81-1.61-9.3,4.79-11.53,8.39-19.85,4.12-8.37,13.57-2.11,11.23,8.81-1.84,11.27,2.51-.37,5.71,4.71,2.73,4.2-8,22.28-3.26,20.65,4.39-2,8.17.77,7.59,5.82C201.77,156.66,198,173.59,198.16,173.82Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.66,178.58a.16.16,0,0,1-.13-.06,79.09,79.09,0,0,1-15.93-29.83v-.1h-.08a43.61,43.61,0,0,1-8.46-7.11c-.85-.88-1.7-1.78-2.55-2.69a.14.14,0,0,1,0-.15.19.19,0,0,1,.23-.11h0c.83.88,1.66,1.77,2.5,2.63a45.59,45.59,0,0,0,7.74,6.67l.47.3-.15-.57A75.36,75.36,0,0,1,183,130.93v-.16l-.13-.06h-.06a42.81,42.81,0,0,1-5.18-11.19.14.14,0,0,1,0-.17.18.18,0,0,1,.2,0,.15.15,0,0,1,.06.09,41.81,41.81,0,0,0,4.65,10.34c.13.22.27.43.41.65v-.79a84.37,84.37,0,0,1,1.72-17.79.13.13,0,0,1,.06-.1.15.15,0,0,1,.16,0,.18.18,0,0,1,.07.19,82.45,82.45,0,0,0-1.39,23.87v.47l.32-.31a60.34,60.34,0,0,0,9.24-11.17s.06-.07.12,0a.26.26,0,0,1,.11.14.12.12,0,0,1,0,.14,60.81,60.81,0,0,1-9.62,11.55l-.1.09v.14a74,74,0,0,0,2.11,11.53v.06h0a.14.14,0,0,1,0,.15v.12a72.62,72.62,0,0,0,3.52,9.92l.25.57c0-.2.11-.4.16-.6a58,58,0,0,1,6.6-15.27.14.14,0,0,1,.18-.07.18.18,0,0,1,.11.1.09.09,0,0,1,0,.1,58.21,58.21,0,0,0-6.82,16.1v.16a80.71,80.71,0,0,0,11.87,18.65.11.11,0,0,1,0,.11.26.26,0,0,1-.17.12Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.32,202.28a54.54,54.54,0,0,0-1.45-16.2c-2-7.91-7-15.51-13.51-12.69-9,4.27-13.46-12.62-18.84-8-4.89,4.83-1.74,6.5-10.4,3-8.92-3.18-12.21,3.37-21,6-9,3.13-4.39,14.3,6.8,13.48,11.44-.23-.8,2.65,3.68,6.89,3.68,3.59,23.37-5.17,20.94-.3-2.69,4.42-.62,8.93,4.47,9.09C162.75,203.5,180.13,202,180.32,202.28Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.42,206.79a.17.17,0,0,0,0-.14c-5.81-7.44-15.15-16.34-26.76-21.83h-.09v-.1A46.94,46.94,0,0,0,152,174.5c-.73-1.06-1.48-2.11-2.23-3.17a.12.12,0,0,0-.14,0,.21.21,0,0,0-.15.22v.07c.73,1,1.46,2.06,2.18,3.1a48,48,0,0,1,5.26,9.39l.22.55-.53-.24a68.91,68.91,0,0,0-16-5.07h-.15v-.16a.09.09,0,0,0,0-.07,40.75,40.75,0,0,0-10.16-7.32.19.19,0,0,0-.18,0,.21.21,0,0,0-.07.21.18.18,0,0,0,.09.08,40.73,40.73,0,0,1,9.42,6.62l.57.55-.78-.14a77.49,77.49,0,0,0-17.87-.91c-.08,0-.1,0-.1,0a.19.19,0,0,0,0,.18.16.16,0,0,0,.17.1,76.13,76.13,0,0,1,23.82,2.22l.46.12-.36.3a62.39,62.39,0,0,1-12.61,8.22s-.08,0-.06.12a.29.29,0,0,0,.12.15.17.17,0,0,0,.14,0A62.29,62.29,0,0,0,146,181l.11-.1h.13a68.15,68.15,0,0,1,11,4.07h.06V185a.17.17,0,0,0,.15.06h.12a68,68,0,0,1,9.2,5.35l.51.35-.61.08a56,56,0,0,0-16.21,4.74.17.17,0,0,0-.09.18.15.15,0,0,0,.07.14h.1a56,56,0,0,1,17.06-4.84h.17a80.89,80.89,0,0,1,16.4,15.71c0,.06.08,0,.1,0a.22.22,0,0,0,.14-.17Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.18,186c-.09,0,5.5-7.51,7.8-16.67,2.49-9,1.68-19.58-6.73-21.11-11.83-1.75-6.71-21-15-20-7.85,1.5-5.54,5.18-12.5-3.89-7.42-8.9-14.6-4.7-25.24-8-11.1-2.81-12.76,11-.69,17.51,12,7.25-2.35,2-.14,9.09,1.76,5.89,27.21,10.23,21.9,13.37-5.34,2.53-5.77,8.26-.58,11.73C156.27,175.74,175.14,185.63,175.18,186Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.85,193.07a.22.22,0,0,0,.05-.17,97.26,97.26,0,0,0-15.23-38.62l-.07-.1v-.11a52.61,52.61,0,0,0,.08-13.56c-.14-1.5-.31-3-.49-4.53a.14.14,0,0,0-.12-.14.21.21,0,0,0-.27.12v.09c.17,1.48.34,3,.49,4.43a55.35,55.35,0,0,1,.07,12.54,4,4,0,0,1-.1.68c-.13-.2-.27-.39-.41-.59a91.24,91.24,0,0,0-13.73-15.38l-.14-.13v-.17a.17.17,0,0,0,0-.1,51.91,51.91,0,0,0-6.34-13.73.18.18,0,0,0-.19-.1.19.19,0,0,0-.19.16.15.15,0,0,0,0,.13,51.5,51.5,0,0,1,6,12.57c.09.3.19.6.28.9l-.73-.64a103.19,103.19,0,0,0-18-12.54h-.14a.19.19,0,0,0-.1.17.21.21,0,0,0,.12.21,101.47,101.47,0,0,1,23.44,17.69c.13.14.26.28.4.41l-.54.06a74.65,74.65,0,0,1-17.8-.25c-.07,0-.11,0-.13.09a.26.26,0,0,0,0,.21.21.21,0,0,0,.15.09,74.46,74.46,0,0,0,18.45.2h.17l.11.12a88.55,88.55,0,0,1,9.1,11.15l.05.06v.08a.19.19,0,0,0,.11.16h.07l0,.07a92.69,92.69,0,0,1,6.46,11.18l.34.68-.68-.32a71.5,71.5,0,0,0-19.54-6,.17.17,0,0,0-.2.11.28.28,0,0,0,0,.18.12.12,0,0,0,.11.07,71.61,71.61,0,0,1,20.48,6.43l.1,0v.1a99.44,99.44,0,0,1,8,25.93.12.12,0,0,0,.08.12.26.26,0,0,0,.24-.07Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.14,
    y: 77.01,
    width: 128.16,
    height: 231.38,
    rx: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M279.53,157.72H184.68A16.66,16.66,0,0,0,168,174.36V372.44a16.6,16.6,0,0,0,6.43,13.12L294.81,167.77A16.64,16.64,0,0,0,279.53,157.72Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M250.62,165.83H215.44a1.78,1.78,0,0,0-1.76,1.76h0a1.76,1.76,0,0,0,1.76,1.76h35.18a1.76,1.76,0,0,0,1.76-1.76h0A1.78,1.78,0,0,0,250.62,165.83Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.53,164H265.61l-5,9.49a10.8,10.8,0,0,1-9.56,5.77H213.17a10.8,10.8,0,0,1-9.56-5.77l-5-9.49H184.68a10.44,10.44,0,0,0-10.42,10.42v198a10.43,10.43,0,0,0,10.42,10.41h94.85a10.42,10.42,0,0,0,10.41-10.41V174.38A10.42,10.42,0,0,0,279.53,164Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.94,174.38v2.2L177.52,380a10.43,10.43,0,0,1-3.26-7.57v-198A10.43,10.43,0,0,1,184.68,164H198.6l5,9.49a10.82,10.82,0,0,0,9.57,5.77H251a10.8,10.8,0,0,0,9.56-5.77l5-9.49h13.92a10.43,10.43,0,0,1,10.46,10.38Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 157.15,
    y: 113.07,
    width: 158.65,
    height: 50.24,
    rx: 7.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M255.12,210.54l1,3a.5.5,0,0,0,.48.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.18.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08l-2.6-1.81a.51.51,0,0,0-.6,0l-2.55,1.86a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.51.51,0,0,0-.19-.57l-2.55-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,.66-.29A.49.49,0,0,1,255.12,210.54Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.66,210.54l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41L275,216.68a.52.52,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57L272.48,219a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.52.52,0,0,0-.19-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.5.5,0,0,1,.64-.3A.49.49,0,0,1,272.66,210.54Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M290.21,210.54l1,3a.5.5,0,0,0,.48.35h3.17a.51.51,0,0,1,.29.92l-2.55,1.86a.51.51,0,0,0-.19.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08L290,219a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.5.5,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,1-.05Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M307.76,210.54l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.5.5,0,0,0-.18.57l1,3a.51.51,0,0,1-.78.57L307.57,219a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.51.51,0,0,0-.19-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.17a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,.66-.29A.49.49,0,0,1,307.76,210.54Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M325.3,210.54l1,3a.52.52,0,0,0,.49.35H330a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57l-2.6-1.81a.51.51,0,0,0-.6,0L322,220.83a.51.51,0,0,1-.78-.57l1-3a.5.5,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.52.52,0,0,1,.7-.19A.55.55,0,0,1,325.3,210.54Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 145.15,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 221.13,
    y: 121.83,
    width: 51.02,
    height: 2.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 150.55,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 155.56,
    width: 23.32,
    height: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 189.62,
    cy: 138.93,
    r: 20.37
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.59,232l-1.79-18.82c0-4.82-1.89-9.26-7-7.94h0a6.13,6.13,0,0,0-7.06.86,10.74,10.74,0,0,0-3.14,7.71l-2,18.29Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M220.51,222.32v4.14s-.58,3.24-3.31,3.79a4.78,4.78,0,0,1-3.28-3.79v-4.14Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M220.51,221.73v2.64a7,7,0,0,1-6.59,0v-2.64Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.9,213.39a7.49,7.49,0,0,1-5-2.43c-1.85,1.6-8.32,2.43-8.32,2.43v2.55a11.06,11.06,0,0,0,2.11,6.06,5.69,5.69,0,0,0,8,1.19,5.84,5.84,0,0,0,1.19-1.19,11.06,11.06,0,0,0,2.11-6.06Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M233.51,233.36c-2.58-4.44-13.51-6.9-13.51-6.9l-2.87,1.11-2.87-1.11s-10.93,2.46-13.51,6.9l-3.17,23.92,5-.08,2.94-20s1.86,6.45,1.76,10.22a83.86,83.86,0,0,1-1.28,10h22.2a83.86,83.86,0,0,1-1.28-10c-.1-3.77,1.76-10.22,1.76-10.22l2.94,20,5,.08Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.68,231.55",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226,228.32a9.19,9.19,0,0,1-17.64,0,26.54,26.54,0,0,0-4.86,2.42l2,6.51a.89.89,0,0,1,.08.17v-.17l.21.75.06.23a40.69,40.69,0,0,1,1.49,9.24,83.86,83.86,0,0,1-1.28,10h22.2a83.86,83.86,0,0,1-1.28-10c-.1-3.77,1.76-10.22,1.76-10.22v.27c0-.09.09-.18.14-.27l2-6.47A24.81,24.81,0,0,0,226,228.32Z",
    transform: "translate(-27.88 -80.71)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M358.12,252.11a2,2,0,0,1-1.73-1.06L346,230.27s-1.25-5-2.72-5l-.15,6.62,7.06,25.54c.41,1.6,1.24,3,3.37,3A93.61,93.61,0,0,1,371,263.29a19.1,19.1,0,0,0,9.73,0C381,251.57,362.57,252.21,358.12,252.11Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M373.74,249.5v5.91h-9v-3.33s-5.9-1.39-5.61-6.72,2.79-7.9,4.14-8.31,7.86,2.21,8,2.54.82,6,.82,6Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M364.32,241.43s1.59-2.24,3.07-1.13.74,3.33-1.11,4.44c0,0,1.85,6.3,5.55,5.93a9.69,9.69,0,0,0,8.05-10.38c-.41-6.1-8.38-10.4-12.73-9.54S358.47,236.48,364.32,241.43Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M379.84,236.44s4.83-6.15,9.66-.82,7.87,11.3,10.08,12.45-1.89,3.93-7.21,2.21S380.17,242,379.84,236.44Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M364.77,255.41v-3.33s3.67.14,5.23-1.28c0,0-1.1,2.54-3.49,2.61v2Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M360.83,302.66s2.12,33,4.8,39.95S385.33,381,385.33,381l8.81-1.93-12.56-37.58c-.1,2.3-1.77-8.53,1.34-19.5a27.39,27.39,0,0,0-1.61-19.06l-22-.24",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.14,301.27s-.82,9.17-11.38,19.59-14.83,17.57-14.83,17.57L353.34,384h-8.78s-5.19-48-5.05-49.7,14.7-33,16.43-35.72S381.14,301.27,381.14,301.27Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M374.66,254.93s9.42.71,5.95,12.39c-3.79,12.77.56,33.24,1.42,35.35l-2.82,1.13a35.21,35.21,0,0,1-26.16-.56h0s7.49-16.52,2.16-25.16c-3.42-5.56-2.41-11.17,1.59-16.14,2.59-3.21,5.86-6.57,7.15-6.63Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M344.56,384h1.86l-3.77-49.35c.63-1,2.78-5,9.3-17.52a67.44,67.44,0,0,0,5-12.46,32.92,32.92,0,0,1-3.5-1.22c-4.65,9.56-13.81,29.49-13.93,30.85C339.37,336,344.56,384,344.56,384Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M362.8,275c-4.4,1.63-1.13,13.32-5.86,29.65a38.23,38.23,0,0,1-3.89-1.38h0s7.49-16.52,2.16-25.16a12.77,12.77,0,0,1-2-8.18l18.68-4.24S368.79,272.75,362.8,275Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M322.54,245.71s17.1,28.42,22.09,30c2.22.72,16.05-4.68,21.88-5.64a6.09,6.09,0,0,0,5.08-6.56h0c-.34-3.65-4.52-6.75-8.1-6l-19.19,6S328,246.74,324.42,242.9c0,0-1.5-4.73-3.73-4.73C318.7,238.17,321.72,244.08,322.54,245.71Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M336.18,386.86c2.42-.79,6.95-1.75,8.6-2.91h8.53c-.08,1.71-.13,3.38-.15,4.48a1.36,1.36,0,0,1-1.37,1.33h-17a1.09,1.09,0,0,1-.57-2A8.29,8.29,0,0,1,336.18,386.86Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M377.79,385.75c2.18-1.31,6.38-3.27,7.72-4.77l8.31-1.93c.31,1.69.64,3.32.86,4.4a1.35,1.35,0,0,1-1,1.6l-16.55,3.84a1.09,1.09,0,0,1-1.29-.86,1.07,1.07,0,0,1,.29-1A9,9,0,0,1,377.79,385.75Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.63,266c4,.1,22-6.64,26.78-3.42-.88-3.22-4.65-5.76-7.92-5l-19.19,6S328,246.74,324.42,242.9C324.42,242.9,340.26,265.93,344.63,266Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M379.71,236.07l-1.25.23a9,9,0,0,1,1.28,5.1l1.62-.31S381.19,236.6,379.71,236.07Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 87.81,
    y: 174.95,
    width: 158.65,
    height: 50.24,
    rx: 7.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M185.77,272.42l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.5.5,0,0,0-.18-.57L180,276.69a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.51.51,0,0,1,.7-.17A.46.46,0,0,1,185.77,272.42Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M203.32,272.42l1,3a.5.5,0,0,0,.48.35H208a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.18.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08l-2.56-1.86a.5.5,0,0,0-.59,0L200,282.71a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.52.52,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.5.5,0,0,0,.48-.35l1-3a.52.52,0,0,1,.68-.24A.49.49,0,0,1,203.32,272.42Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M220.87,272.42l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.5.5,0,0,0-.18.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.52.52,0,0,0-.19-.57L215,276.7a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.51.51,0,0,1,.68-.25A.56.56,0,0,1,220.87,272.42Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M238.41,272.42l1,3a.5.5,0,0,0,.48.35H243a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.51.51,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.5.5,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21H236a.52.52,0,0,0,.49-.35l1-3a.52.52,0,0,1,.68-.24A.51.51,0,0,1,238.41,272.42Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M256,272.42l1,3a.5.5,0,0,0,.48.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.5.5,0,0,0-.18.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08l-2.56-1.86a.51.51,0,0,0-.6,0l-2.55,1.86a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.51.51,0,0,0-.19-.57l-2.55-1.86a.51.51,0,0,1-.11-.71.5.5,0,0,1,.4-.21h3.17a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,.69-.2A.55.55,0,0,1,256,272.42Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 151.79,
    y: 207.04,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 151.79,
    y: 183.71,
    width: 51.02,
    height: 2.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 151.79,
    y: 212.43,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 151.79,
    y: 217.44,
    width: 23.32,
    height: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 120.26,
    cy: 200.83,
    r: 20.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M104.64,359.35s34.55-28.94,40.62-18.71S142.39,384,142.39,384Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M122.77,371.18,142.39,384s8.18-30.28,3.57-41.87C148.07,357.35,131.9,367,122.77,371.18Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.34,356.26s21.39,17.17,23.14,23.35c2.82,10-13.93,8.91-21.17,8.91S71,387.24,71,387.24l.41-7.09,42.55-2S90.35,374.63,91.23,361,122.34,356.26,122.34,356.26Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M144.32,385.28c-3.91,3.86-14.6,3.23-20,3.23-7.24,0-53.36-1.27-53.36-1.27l.43-7.1,42.54-2s17,8.16,30.06,7.2Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M71.17,387.12s-1.87,4.23-.44,7-4.79.76-5.79-4.76-.52-12.11,6.43-9.15Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.15,313.72s15.53-44.88,16-44.68a38,38,0,0,0,5,1.55l-6.4,49.26Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.2,308.6c-3.53-1.67-8-3.62-13.12-3.3-2.13,6.11-2.93,8.42-2.93,8.42l14.61,6.13Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.6,301.85c-1.15,4.24-5.7,3.45-5.7,3.45v4h-7.84v-5.45h0c4.07.94,8.5-2,6.54-3.48s-2.36-3.85-1.35-5,3.48-.3,3.48-.3a12.41,12.41,0,0,0,5-.89A19.23,19.23,0,0,1,114.6,301.85Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.76,295.09s-2.45-.88-3.46.29-.61,3.59,1.35,5-2.48,4.41-6.56,3.47-6.35-9.45-2.85-15c3.21-5.08,14.49-7.29,16.77-2S117.41,294.88,109.76,295.09Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M108.9,309.33v-4a16.55,16.55,0,0,1-3.67-.9,9.11,9.11,0,0,0,2.29,2v2.89Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111,309.41S98,304.92,94.38,315s2.56,34.34-4,42.65h0a41.64,41.64,0,0,0,32.48,1.18l1.42-.54s-4.53-30.9-4.75-29.82c-.18.9,15.31,5.84,18.4,4.15s21.78-22.79,21.78-22.79l-6.29-.93L136.52,320S115.26,309.68,111,309.41Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M159.66,309.85s6.48-2.79,6.88-4.07H157.2a3,3,0,0,0-2.45,1.24l-1.38,1.9Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M124.23,358.31s-4-27.14-4.66-29.66a2.7,2.7,0,0,0,.39.27l-.48-.43s-9.88-2.4-13.4-6.56c0,0,3.36,6.88,7.68,8.48,3.85,1.42,2.48,22.23,5.45,29.62,1.21-.33,2.42-.72,3.6-1.17Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M111.62,269.26s1.65-5.89,4.11-6.31v7.69Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M170.51,311.38l-1.31-11.76a6.52,6.52,0,0,0-2.92-4.65l-4.08-2.67v0l-3.36-1.3-3.43-1.33-2.83-1.09-1.25-.49-3.12,1.6-3.11-1.6-1.1.43-2.67,1-3.62,1.4-3.48,1.35v.06l-4,2.6a6.52,6.52,0,0,0-2.92,4.65L126,311.38h8.27v9.78H162.1v-9.78Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M148.33,267.45h0a8.32,8.32,0,0,0-8.32,8.31v4h16.63v-4a8.31,8.31,0,0,0-8.31-8.31Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M151.62,285.92v2.91a1.89,1.89,0,0,1-.05.23c-.43,1.72-1.88,5-3.31,5s-2.82-3.41-3.14-5.15v-3Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M151.62,285.34v2.6a6.89,6.89,0,0,1-6.51,0v-2.6Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M144,279.76a2,2,0,1,0-2,2A2,2,0,0,0,144,279.76Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M156.59,279.76a2,2,0,1,0-2,2A2,2,0,0,0,156.59,279.76Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M155,276.34a14.4,14.4,0,0,1-3.35-2.39h-6.54c-.53,1.48-3.27,2.39-3.27,2.39l-.06,3.27a11,11,0,0,0,2.09,6,5.62,5.62,0,0,0,7.87,1.13,5.5,5.5,0,0,0,1.13-1.13,11,11,0,0,0,2.08-6Z",
    transform: "translate(-27.88 -80.71)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 157.15,
    y: 236.46,
    width: 158.65,
    height: 50.24,
    rx: 7.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M255.12,333.93l1,3a.5.5,0,0,0,.48.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.18.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08L255,342.34a.51.51,0,0,0-.6,0l-2.55,1.86a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.51.51,0,0,0-.19-.57l-2.55-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,.69-.2A.55.55,0,0,1,255.12,333.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.66,333.93l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41L275,340.07a.52.52,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.52.52,0,0,0-.19-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.5.5,0,0,1,.65-.29A.51.51,0,0,1,272.66,333.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M290.21,333.93l1,3a.5.5,0,0,0,.48.35h3.17a.51.51,0,0,1,.29.92l-2.55,1.86a.51.51,0,0,0-.19.57l1,3a.51.51,0,0,1-.32.65.52.52,0,0,1-.47-.08L290,342.36a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.71-.1.5.5,0,0,1-.08-.47l1-3a.5.5,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,1,0Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.64,333.6a.5.5,0,0,0-.4.33l-1,3a.5.5,0,0,1-.48.35H284.6a.51.51,0,0,0-.51.51.52.52,0,0,0,.21.41l2.56,1.86a.5.5,0,0,1,.18.57l-1,3a.51.51,0,0,0,.32.65.52.52,0,0,0,.47-.08l2.56-1.86a.38.38,0,0,1,.21-.07Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M307.76,333.93l1,3a.52.52,0,0,0,.49.35h3.16a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.5.5,0,0,0-.18.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0l-2.56,1.86a.51.51,0,0,1-.78-.57l1-3a.51.51,0,0,0-.19-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.17a.5.5,0,0,0,.48-.35l1-3a.51.51,0,0,1,.7-.17A.46.46,0,0,1,307.76,333.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M325.3,333.93l1,3a.52.52,0,0,0,.49.35H330a.51.51,0,0,1,.51.51.52.52,0,0,1-.21.41l-2.56,1.86a.52.52,0,0,0-.19.57l1,3a.51.51,0,0,1-.78.57l-2.56-1.86a.51.51,0,0,0-.6,0L322,344.22a.51.51,0,0,1-.78-.57l1-3a.5.5,0,0,0-.18-.57l-2.56-1.86a.51.51,0,0,1-.11-.71.52.52,0,0,1,.41-.21h3.16a.52.52,0,0,0,.49-.35l1-3a.52.52,0,0,1,.7-.19A.55.55,0,0,1,325.3,333.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 268.55,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 221.13,
    y: 245.22,
    width: 51.02,
    height: 2.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 273.94,
    width: 51.02,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.13,
    y: 278.95,
    width: 23.32,
    height: 1.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 189.6,
    cy: 261.76,
    r: 20.37
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.28,338.12s-1.16-4.62.64-6.65,5.37-4.19,8.28-3.08a4.74,4.74,0,0,1,4.39-.23c2.09,1.16,5.11,2.17,5.43.78,0,0,.17,5.32-2.21,6.16l-1,4.09H209.57Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.51,356.19c-2.58-4.44-13.51-6.9-13.51-6.9l-2.87,1.11-2.87-1.11s-10.93,2.46-13.51,6.9l-3.17,23.92,5-.08,2.94-20s1.86,6.45,1.76,10.22a83.86,83.86,0,0,1-1.28,10h22.2a83.86,83.86,0,0,1-1.28-10c-.1-3.77,1.76-10.22,1.76-10.22l2.94,20,5,.08Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.68,354.38",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M220.51,345.15v4.14s-.58,3.24-3.31,3.79a4.78,4.78,0,0,1-3.28-3.79v-4.14Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M220.51,344.56v2.64a7,7,0,0,1-6.59,0v-2.64Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.9,336.22a7.49,7.49,0,0,1-5-2.43c-1.85,1.6-8.32,2.43-8.32,2.43v2.55a11.06,11.06,0,0,0,2.11,6.06,5.69,5.69,0,0,0,8,1.19,5.84,5.84,0,0,0,1.19-1.19,11.06,11.06,0,0,0,2.11-6.06Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M212.27,339.08a1.83,1.83,0,1,1-1.83-1.83h0A1.83,1.83,0,0,1,212.27,339.08Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.76,339.08a1.83,1.83,0,1,1-1.83-1.83h0A1.83,1.83,0,0,1,225.76,339.08Z",
    transform: "translate(-27.88 -80.71)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 281.76,
    cy: 29.89,
    r: 29.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M309.64,80.75h-.54a27.95,27.95,0,0,1-14.18,52,27.54,27.54,0,0,1-5.93-.64,29.85,29.85,0,1,0,20.65-51.4Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.57,205.05c6.25,0,6.58-9.31.34-9.7h-.17v-.12a12,12,0,0,0-17.83-10.56,12.5,12.5,0,0,0-23.52,5.91,10.09,10.09,0,0,0,0,1.1,14.57,14.57,0,0,0-16.12,5.87,4.85,4.85,0,0,0,4.07,7.51Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.61,129c8.19,0,8.62-12.19.45-12.72h-.23v-.15a15.78,15.78,0,0,0-23.36-13.84A16.38,16.38,0,0,0,237.65,110q0,.73.06,1.44a19.13,19.13,0,0,0-21.12,7.7,6.35,6.35,0,0,0,5.33,9.84Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.17,157.74c-7.53,0-7.92-11.2-.41-11.68H390v-.14a14.5,14.5,0,0,1,21.46-12.72,15.06,15.06,0,0,1,28.33,7.12q0,.68-.06,1.32a17.56,17.56,0,0,1,19.41,7.08,5.84,5.84,0,0,1-1.75,8.07,5.77,5.77,0,0,1-3.15.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416.68,367.45l1.48-.49c.22-2.56-.88-6.87-6.69-13.52-10.75-12.31-20-29.84-17.63-36.68,0,0-10.52,15.82-3.42,26.27C397.07,352.83,414.77,354.94,416.68,367.45Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M417.29,367.25l.87-.29c.22-2.56-.88-6.87-6.69-13.52-10.75-12.31-20-29.84-17.63-36.68,0,0-5.57,14.54,1.65,24.28S415.33,352.65,417.29,367.25Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M421,356.93a30.82,30.82,0,0,1-2,6.14l.69.11c3.15-4.24,8.32-12.65,9.46-23.31,1.68-15.58,3.94-35.09,3.94-35.09s-15.87,13.09-12.31,31.28C422.53,345.13,422.07,352,421,356.93Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M426.57,328.62c-.87,13-3.32,27.3-6.5,33,.46-.36.95-.73,1.46-1.11a47.93,47.93,0,0,0,7.6-20.63c1.68-15.58,3.94-35.09,3.94-35.09S427.7,311.69,426.57,328.62Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.83,363a23.72,23.72,0,0,1-3.62,3.39l.42.33a37.73,37.73,0,0,0,15-12.21c6.9-9.87,15.64-22.17,15.64-22.17s-15.54,3-19.87,16.52A39.21,39.21,0,0,1,423.83,363Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M438.07,346c-5.4,8.44-12.34,17.17-16.59,19.82l1.39-.21a36.82,36.82,0,0,0,12.76-11.09c6.9-9.87,15.64-22.17,15.64-22.17S445.09,335,438.07,346Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.88,362.5c1,2.78,1.69,4.68,2.11,6l.56-.13c-.91-4.87-2.49-13.29-4-18.81-2.19-8.14-.49-12.09-2.25-26.25s-10.16-32.86-10.16-32.86-5.42,19.73,2.33,38.56S413.59,350.27,417.88,362.5Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M420,368.49h.11l.06-2c-.93-5-2.31-12.06-3.62-16.92-2.19-8.14-.49-12.09-2.25-26.25s-10.16-32.86-10.16-32.86,2.64,28.12,6.49,40.42C414.21,342.24,419.28,365.13,420,368.49Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M404,365.65l3.39,20.11a3.91,3.91,0,0,0,3.85,3.25h19.65a3.9,3.9,0,0,0,3.84-3.25l3.4-20.11a3,3,0,0,0-2.48-3.44,2.38,2.38,0,0,0-.46,0H406.91a3,3,0,0,0-3,3.05A3.13,3.13,0,0,0,404,365.65Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M438.09,364.63h0a3.47,3.47,0,0,0-.16-.55h0a4.16,4.16,0,0,0-.24-.47l-.06-.08a3.27,3.27,0,0,0-.28-.37l-.13-.12-.3-.26-.23-.14a1.56,1.56,0,0,0-.28-.16l-.36-.12-.23-.08a3.39,3.39,0,0,0-.64-.07H406.91a3,3,0,0,0-3,3v.06h25.24a2.94,2.94,0,0,1,0,.42l-3.4,20.11a3.89,3.89,0,0,1-3.84,3.25h8.95a3.9,3.9,0,0,0,3.84-3.25l3.4-20.11A2.91,2.91,0,0,0,438.09,364.63Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M144.47,219H100.1a5.76,5.76,0,0,0-5.77,5.75h0v34.86l11.29-10.23A5,5,0,0,1,109,248.1h35.5a4,4,0,0,0,3.95-4V222.9A4,4,0,0,0,144.47,219Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M129.27,227.89a4.91,4.91,0,0,0-6.94-.06l-.06.06-.65.65-.65-.65a4.95,4.95,0,0,0-7,7l.65.65,7,7,7-7,.65-.65a4.91,4.91,0,0,0,.06-6.94l-.06-.06Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.29,171.9H363.66a5.8,5.8,0,0,0-5.79,5.8v35.06l11.35-10.28a5,5,0,0,1,3.37-1.3h35.7a4,4,0,0,0,4-4v-21.3A4,4,0,0,0,408.29,171.9Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M397.74,187.82a1.55,1.55,0,0,0-.13-3.09h-3.47a8.4,8.4,0,0,1-2.35-.12c-1.31-.29.24-1.89-.58-4.83s-3.69-2.77-3.55-1.4.29,4.65-.47,5.68a6.78,6.78,0,0,1-4.52,2.56l-.06,7.79h3.06a7.46,7.46,0,0,0,4.25,2h5.83a1.41,1.41,0,0,0,1.42-1.4h0a1.44,1.44,0,0,0-.53-1.11,1.55,1.55,0,0,0,.38-3h.22a1.54,1.54,0,0,0,1.55-1.53v0h0A1.56,1.56,0,0,0,397.74,187.82Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.15 115.13 351.39 115.14 351.46 103.76 346.21 103.75 346.15 115.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M306.38,299.17a14.46,14.46,0,1,1,7.46,6.36,4.42,4.42,0,0,0-2.85-.1l-5.63,1.7,1.38-4.55A4.28,4.28,0,0,0,306.38,299.17Z",
    transform: "translate(-27.88 -80.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M318.62,284.2l-1.48,4.58a.65.65,0,0,1-.6.43h-4.81a.62.62,0,0,0-.64.6.65.65,0,0,0,.27.53l3.89,2.83a.62.62,0,0,1,.23.7L314,298.45a.63.63,0,0,0,1,.7l3.89-2.83a.63.63,0,0,1,.74,0l3.89,2.83a.63.63,0,0,0,1-.7L323,293.87a.61.61,0,0,1,.22-.7l3.9-2.83a.62.62,0,0,0,.16-.86.6.6,0,0,0-.53-.27H321.9a.63.63,0,0,1-.6-.43l-1.49-4.58a.62.62,0,0,0-.77-.42A.63.63,0,0,0,318.62,284.2Z",
    transform: "translate(-27.88 -80.71)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetA);
export default __webpack_public_path__ + "static/media/asset-a.93201afe35c94b65b4d827af12582844.svg";
export { ForwardRef as ReactComponent };